import Forms from "../Components/Forms/Forms";

export default function FaleConosco() {
  return (
    <div>
      <Forms />
    </div>
  );
}
